export default {
  namespaced: true,
  state: {
    FirstName: '',
    LastName: '',
    DateOfBirth: '',
    DLNumber: '',
    TestType: 'D',
    TestTypeText: '',
    TestTypeId: '',
    Email: '',
    Phone: '',
    HomePhone: '',
  },
  mutations: {
    firstName(state, payload) {
      state.FirstName = payload.value;
    },
    lastName(state, payload) {
      state.LastName = payload.value;
    },
    dateOfBirth(state, payload) {
      state.DateOfBirth = payload.value;
    },
    dLNumber(state, payload) {
      state.DLNumber = payload.value;
    },
    testType(state, payload) {
      state.TestType = payload.value;
    },
    testTypeText(state, payload) {
      state.TestTypeText = payload.value;
    },
    testTypeId(state, payload) {
      state.TestTypeId = payload.value;
    },
    email(state, payload) {
      state.Email = payload.value;
    },
    phone(state, payload) {
      state.Phone = payload.value;
    },
    homePhone(state, payload) {
      state.HomePhone = payload.value;
    },
  },
  actions: {
    firstName(context, payload) {
      context.commit('firstName', payload);
    },
    lastName(context, payload) {
      context.commit('lastName', payload);
    },
    dateOfBirth(context, payload) {
      context.commit('dateOfBirth', payload);
    },
    dLNumber(context, payload) {
      context.commit('dLNumber', payload);
    },
    testType(context, payload) {
      context.commit('testType', payload);
    },
    testTypeText(context, payload) {
      context.commit('testTypeText', payload);
    },
    testTypeId(context, payload) {
      context.commit('testTypeId', payload);
    },
    email(context, payload) {
      context.commit('email', payload);
    },
    phone(context, payload) {
      context.commit('phone', payload);
    },
    homePhone(context, payload) {
      context.commit('homePhone', payload);
    },
  },
  getters: {
    firstName(state) {
      return state.FirstName;
    },
    lastName(state) {
      return state.LastName;
    },
    dateOfBirth(state) {
      return state.DateOfBirth;
    },
    dLNumber(state) {
      return state.DLNumber;
    },
    testType(state) {
      return state.TestType;
    },
    testTypeText(state) {
      return state.TestTypeText;
    },
    testTypeId(state) {
      return state.TestTypeId;
    },
    email(state) {
      return state.Email;
    },
    phone(state) {
      return state.Phone;
    },
    homePhone(state) {
      return state.HomePhone;
    },
  },
};
